export default __webpack_public_path__ + "static/media/default_coverphoto.96705eef.png";